export const CONCESSIONS = 'concessions-pos'
export const KIOSK = 'kiosk'
export const CFD = 'cfd'

export const DEVICE_TYPES = [CONCESSIONS, KIOSK, CFD]

const DISPLAY_NAMES = {
  [CONCESSIONS]: 'Concessions POS',
  [KIOSK]: 'Kiosk',
  [CFD]: 'Customer Facing Display POS',
}

const PRINTING_TYPES = {
  [CONCESSIONS]: 'pos',
  [KIOSK]: 'kiosk',
}

const RECEIPT_TYPES = {
  [CONCESSIONS]: 'receipt',
  [KIOSK]: 'receipt',
}

class DeviceSubtypes {
  static all = [CONCESSIONS, KIOSK]
  static displayName = (type) => DISPLAY_NAMES[type]
  static isConcessions = (type) => type === CONCESSIONS
  static isCFD = (type) => type === CFD
  static isKiosk = (type) => type === KIOSK
  static printerDeviceType = (type) => PRINTING_TYPES[type]
  static printerReceiptType = (type) => RECEIPT_TYPES[type]

  static get concessions() {
    return CONCESSIONS
  }

  static get kiosk() {
    return KIOSK
  }
}

export default DeviceSubtypes
